export default __webpack_public_path__ + "static/media/cold-wave.150d8809.svg";